<template>
<div class="widthFull center pt-0 pb-3 mb-5">
  <loading v-if="loadingState" />

  <div class="row justify-content-center text-left pt-2">

    <div class="col-md-6 center mb-3 text-center pointer selectBlock" v-on:click="flow = 'cdp'" :class="{'blockActive': flow == 'cdp'}">
      <h1 class="mt-4" :class="{'grey': flow == 'poste' }"> <b> CDP </b> </h1>
      <h4 :class="{'grey': flow == 'poste' }">Cassa Depositi e Prestiti</h4>
    </div>

    <div class="col-md-6 center mb-3 text-center pointer selectBlock" v-on:click="flow = 'poste'" :class="{'blockActive': flow == 'poste'}">
      <h1 class="mt-4" :class="{'grey': flow == 'cdp' }"> <b> Poste Italiane </b> </h1>
      <h4 :class="{'grey': flow == 'cdp' }"> BancoPosta Affari</h4>
    </div>

    <!--  ACTUAL MONTH DISPOSALS ------------------------------------------------------------------------------------------------- -->

    <div class="col-md-12 center">

      <h4><b>Riepilogo Pratiche disponibili per la Cessione (*)</b></h4>
      <p :class="{'red': totalDisposal < min_disposal_price_cdp }"> Importo minimo di Cessione <b>€ {{ min_disposal_price_cdp | formatNumber }} </b> <span class="black">( Solo dopo aver raggiunto questo importo, anche cumulando più Pratiche, potrai cedere il credito )</span></p>

    </div>

    <div class="col-md-6 pr-md-5 pl-md-5 pt-4">

      <div class="buttonTextCont widthfull lightGreen mt-5">
        <h1 class="widthFull mt-0 center pb-0 mb-0"><b> {{ countPractices - countPracticesNextMonth }}</b></h1>
      </div>

      <a class="btn btn-primary btn-green btnRed btn-sm  uppercase widthFull" v-on:click="filter = ''">
        <span class="d-none d-md-inline white"> Pratiche con credito cedibile a <template v-if="flow == 'cdp'" > CDP </template> <template v-if="flow == 'poste'" > Poste Italiane </template> </span>
      </a>


      <div class="buttonTextCont widthfull lightGreen mt-5">
        <h1 class="widthFull mt-0 center pb-0 mb-0"><b>
            <font-awesome-icon class="" icon="euro-sign" size="sm" /> {{ countValues | formatNumber }}
          </b></h1>
      </div>

      <a class="btn btn-primary btn-green btnRed btn-sm  uppercase widthFull" v-on:click="filter = ''">
        <span class="d-none d-md-inline white"> Importo totale del credito cedibile a <template v-if="flow == 'cdp'" > CDP </template> <template v-if="flow == 'poste'" > Poste Italiane </template> </span>
      </a>

      <div class="widthFull center">
        <button type="button" v-scroll-to="{ el: '#nextMonth', offset: -145 }" class="btn btn-primary btnBlue btn-sm mt-5" > Pratiche con credito cedibile dal mese successivo </button>
      </div>

    </div>

    <div class="col-md-6">

      <h5 class="mt-1 pt-0 center mb-3">Elenco Pratiche con credito cedibile <b>dal giorno 11 del mese corrente</b></h5>
      <p class="center mt-0 mb-0">Seleziona le Pratiche per le quali vuoi avviare la cessione del credito </p>

      <div class="selectListBox">
        <template v-if="arrayPracticesAvailable.length" >
        <h5 class="pb-0 pt-0 mt-0" v-for="(item,index) in arrayPracticesAvailable" >
          <div class="form-check pb-0 mb-0">
            <input class="form-check-input pb-0 mb-0" :disabled="moment().date() < 11" type="checkbox" :checked="disposalArray[item.id] && moment().date() >= 11 ? true : false"   v-on:change="selectItemForDisposal(item, $event)" value="" :id="'box_' + index" />
            <label class="form-check-label custLabelFontSize pointer pb-0 mb-0" :for="'box_' + index">
              Pratica N. <b class="underline">{{ item.code }}</b>
              del {{ moment(item.created_at).format('DD-MM-YYYY') }}
              di <b> {{ item.client_lastname }}  {{item.client_name}} </b>
              <p class="mt-1"> <b >{{ item.bonus }}</b> Importo di Cessione : <b >€ {{ item.finalAmmount |  formatNumber }}</b > </p>
            </label>
          </div>
        </h5>
      </template>
      <template v-else >
        <h5 class="pb-0 pt-0 mt-0"  >
          <div class="form-check pb-0 mb-0">
            <label class="form-check-label custLabelFontSize pointer pb-0 mb-0" :for="'box_1231231231'">
              No ci sono pratiche disponibili per cessione
            </label>
          </div>
        </h5>
      </template>

      </div>

      <div class="row pt-4 pb-4">
        <!--
        <div class="widthFull   pb-3">
        <template v-if="flow == 'poste'">
          Valore totale  di cessione delle pratiche selezionate per codice tributo:
          <br/>Bonus cedibili ai sensi dell’art. 121 del DL n. 34/2020:
          <br/>- Ecobonus Ordinario 50% e 65%;
           Codice tributo <b>6922 => € 9.491,30</b>
          <br/>- Bonus Ristrutturazione ( Bonus Casa 50% ); Codice tributo <b>6926 => € 1.197,45</b>
        </template>



        </div>-->

        <div class="col-md-12 center pb-4">
          Importo totale del credito cedibile a <template v-if="flow == 'cdp'" > CDP </template> <template v-if="flow == 'poste'" > Poste Italiane </template> delle Pratiche selezionate: <b :class="{'red' : totalDisposal < min_disposal_price_cdp }"> € {{ totalDisposal | formatNumber }} </b>
        </div>



        <div class="col-md-6 center">
          <button type="button" v-on:click="addAllItemToDisposal()" class="btn btn-primary btnBlue btn-sm" > {{ allChecked ? 'Deseleziona tutte' : 'Seleziona tutte' }} </button>
        </div>
        <div class="col-md-6 center">

          <template v-if=" (flow == 'cdp' && flow_cdp_active) || (flow == 'poste' && flow_poste_active) ">
            <button type="button"  class="btn btn-primary btn-sm btn-green btnRed" v-on:click="addDisposal()" :disabled=" ( totalDisposal < min_disposal_price_cdp ) || moment().date() < 11 " > Avvia Cessione </button>
          </template>
          <template v-else>

            <a v-if="flow == 'poste'" class="btn btn-primary btnYellow btn-sm white small"  disabled v-html="poste_not_active_text">  </a>
            <a v-if="flow == 'cdp'" class="btn btn-primary btnYellow btn-sm white small"  disabled v-html="cdp_not_active_text">  </a>

          </template>


        </div>
      </div>



    </div>

    <div class="col-md-11 pb-3 ">
      <b>* NOTA</b>
      <br/> Nel caso di Ditte Individuali o in assenza di delega all'intermediario abilitato per le Società di capitali o di persone, le stesse dovranno provedere autonamente ad accettare nel proprio cassetto fiscale
       i crediti ceduti dai loro clienti ( utenti finali ) per poter procedere alla cessione del credito.
    </div>


    <!--  FUTURE MONTH DISPOSALS ------------------------------------------------------------------------------------------------- -->
    <!-- DIVIDER -->
    <div class="row justify-content-center divider"> </div>
    <div class="col-md-12 center mt-4 " id="nextMonth">

      <h4><b>Pratiche con credito cedibile dal mese successivo </b></h4>


    </div>

    <div class="col-md-6 pr-md-5 pl-md-5 pt-4">

      <div class="buttonTextCont widthfull lightYellow mt-5">
        <h1 class="widthFull mt-0 center pb-0 mb-0"><b> {{ countPracticesNextMonth }}</b></h1>
      </div>

      <a class="btn btn-primary btnRed  btn-sm  uppercase widthFull" v-on:click="filter = ''">
        <span class="d-none d-md-inline white"> Pratiche con credito cedibile a <template v-if="flow == 'cdp'" > CDP </template> <template v-if="flow == 'poste'" > Poste Italiane </template> dal mese successivo </span>
      </a>


      <div class="buttonTextCont widthfull lightYellow mt-5">
        <h1 class="widthFull mt-0 center pb-0 mb-0"><b>
            <font-awesome-icon class="" icon="euro-sign" size="sm" /> {{ countValuesNextMonth | formatNumber }}
          </b></h1>
      </div>

      <a class="btn btn-primary  btn-sm btnRed  uppercase widthFull" v-on:click="filter = ''">
        <span class="d-none d-md-inline white">Importo totale del credito cedibile a <template v-if="flow == 'cdp'" > CDP </template> <template v-if="flow == 'poste'" > Poste Italiane </template> dal mese successivo </span>
      </a>

    </div>

    <div class="col-md-6">

      <h5 class="mt-1 pt-4 center mb-3">Elenco Pratiche con credito cedibile dal mese successivo</h5>

      <div class="selectListBox lightYellow">
        <template v-if="arrayPracticesNextMonth.length" >
        <h5 class="pb-0 pt-0 mt-0" v-for="(item,index) in arrayPracticesNextMonth">
          <div class="form-check pb-0 mb-0">

            <label class="form-check-label custLabelFontSize pointer pb-0 mb-0" :for="'box_2' + index">
              Pratica N. <b class="underline">{{ item.code }}</b>
              del {{ moment(item.created_at).format('DD-MM-YYYY') }}
              di <b> {{ item.client_lastname }} {{item.client_name}}  </b>
              <p class="mt-1"> <b >{{ item.bonus }}</b> Importo di Cessione: <b >€ {{ item.finalAmmount |  formatNumber }}</b > </p>
            </label>
          </div>
        </h5>
      </template>
      <template v-else >
        <h5 class="pb-0 pt-0 mt-0"  >
          <div class="form-check pb-0 mb-0">
            <label class="form-check-label custLabelFontSize pointer pb-0 mb-0" :for="'box_1231231231'">
              No ci sono pratiche disponibili per cessione dal mese successivo
            </label>
          </div>
        </h5>
      </template>

      </div>

      <div class="col-md-12 center mt-3 pb-4">
          Importo totale del credito cedibile a <template v-if="flow == 'cdp'" > CDP </template> <template v-if="flow == 'poste'" > Poste Italiane </template> dal mese successivo: <b :class="{'red' : totalDisposal < min_disposal_price_cdp }"> € {{ countValuesNextMonth | formatNumber }} </b>
      </div>


    </div>



  </div>
  <form class="pb-5 mb-5 black pt-2 pl-4 pr-4 widthFull vaillantCont" @submit.prevent="editUser()">
    <div class="row justify-content-center pt-4">



    </div>
  </form>

</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import {
  USER_REQUEST,
  USER_SET_DEFAULT_SHIP_DATA
} from 'actions/user'
import Vue from 'vue'



const moment = require('moment')

export default {
  name: 'DisposalAvailable',
  components: {

  },
  props: {

  },
  data() {
    return {
      iban: '',
      ibanNome: '',
      ibanCognome: '',
      loadingState: false,
      flow: 'cdp',
      practices: {},
      loaded: false,
      countPractices: 0,
      moment: require('moment'),
      countValues: 0,
      countPracticesNextMonth: 0,
      countValuesNextMonth: 0,
      arrayPracticesAvailable: [],
      arrayPracticesNextMonth: [],
      min_disposal_price_cdp: process.env.MIN_DISPOSAL_PRICE_CDP,
      min_disposal_price_poste: process.env.MIN_DISPOSAL_PRICE_POSTE,
      disposalArray: {},
      allChecked: false,
      totalDisposal: 0,
      totalDisposalNextMonth: 0,

      flow_cdp_active: process.env.FLOW_CDP_ACTIVE,
      cdp_not_active_text: process.env.FLOW_CDP_NOT_ACTIVE_TEXT,
      flow_poste_active: process.env.FLOW_POSTE_ACTIVE,
      poste_not_active_text: process.env.FLOW_POSTE_NOT_ACTIVE_TEXT,

    }

  },
  methods: {
    addDisposal(){
      if( this.totalDisposal >= this.min_disposal_price_cdp  && moment().date() >= 11 ){
        console.log( 'Send Disposal' )
        var _vue = this
        _vue.loadingState = true

        axios({
            url: process.env.ROOT_API + 'api/addDisposals',
            method: 'POST',
            data: {
              practices: _vue.disposalArray,
              user_token: _vue.getProfile.userToken,
              user: _vue.getProfile,
              flow: this.flow,
              finalAmount: _vue.totalDisposal,
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            _vue.loadingState = false

            if( _vue.flow == 'cdp' ){
              var text = 'Nei prossimi giorni riceverai via e-mail il contratto di cessione da sottoscrivere con le relative istruzioni .'
            }else{
              var text = 'Accedi alla tua area riservata del tuo conto BancoPosta Affari e sottoscrivi il cotratto di cessione del credito in funzione del codice tributo'
            }

            _vue.$swal({
              type: 'success',
              title: '<strong class="modalText danger white">Richiesta di cessione avviata</strong>',
              html: text,
              confirmButtonText: 'CHIUDI',
              confirmButton: 'closeProductsModal',
              confirmButtonColor: '#15267',
              onClose: () => {
                window.location.reload()
              }
            });



          })
          .catch(resp => {
            console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor')
            _vue.addClientError('Riprova più tardi')
            _vue.loadingState = false
          })

      }else{
        console.log( 'Min Value' )
      }

    },
    addAllItemToDisposal(){
      var _vue = this
      _vue.loaded = false
      if( _vue.allChecked == false ){
        _vue.disposalArray = {}
        setTimeout( function(){
        for( var x in _vue.arrayPracticesAvailable ){
          _vue.disposalArray[_vue.arrayPracticesAvailable[x].id] = _vue.arrayPracticesAvailable[x]
        }
        _vue.allChecked = true
        _vue.loaded = true
        console.warn( _vue.disposalArray )
        _vue.calcTotalDisposalValue()
        },2 )
      }else{
        setTimeout( function(){
          for( var x in _vue.arrayPracticesAvailable ){
            delete _vue.disposalArray[_vue.arrayPracticesAvailable[x].id]
          }
          _vue.allChecked = false
          _vue.loaded = true
          console.warn( _vue.disposalArray )
          _vue.calcTotalDisposalValue()
        },2 )
      }
    },
    calcTotalDisposalValue(){
      console.warn( 'Init calc' )
      var _vue = this
      _vue.totalDisposal = 0

      for( var x in _vue.disposalArray ){
        var p = _vue.disposalArray[x].finalAmmount
        p = parseFloat(p.replace(',', '.'))
        _vue.totalDisposal = _vue.totalDisposal + p
        console.log( p )
      }
      _vue.totalDisposal = _vue.totalDisposal.toFixed(2)

    },
    selectItemForDisposal(item,e){
      console.log( item )
      console.log( e.target.checked )

      if( e.target.checked ){
        this.disposalArray[item.id] = item
      }else{
        this.allChecked = false
        delete this.disposalArray[item.id]
      }

      console.warn( this.disposalArray )
      this.calcTotalDisposalValue()
    },
    addClientError(text) {
      this.$swal({
        type: 'error',
        title: '<strong class="modalText danger white">Operazione non andata a buon fine.</strong>',
        html: text,
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267',
      });
    },
    async checkIfExistUser() {
      if (this.getProfile) {
        this.loaded = false
        var data = this.getProfile
        var _vue = this
        _vue.loadingState = true
        axios({
            url: process.env.ROOT_API + 'api/getPracticesWithAvailableDisposals',
            method: 'POST',
            data: {
              type: 'available',
              user_token: data.userToken,
              flow: this.flow
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            _vue.practices = resp.data.practices
            console.log('COUNT ***********************************************')
            console.log(_vue.practices)
            _vue.countPractices = _vue.practices.length
            var count = 0
            var countNextmonth = 0

            _vue.countValues = 0,
            _vue.countPracticesNextMonth = 0,
            _vue.countValuesNextMonth = 0,
            _vue.arrayPracticesAvailable = [],
            _vue.arrayPracticesNextMonth = [],
            _vue.disposalArray = [],
            _vue.allChecked = false,
            _vue.totalDisposal = 0
            _vue.totalDisposalNextMonth = 0

            console.log( ' DAY OF MONTH => ' + moment().date() )

            for (var x in _vue.practices) {
              var adeDate = _vue.practices[x].ade_protocol_number
              adeDate = adeDate.substring(0, 6)
              adeDate = moment(adeDate, "YYMMDD")
              var monthNow = parseInt(moment().format('MM'))
              var monthOfAde = parseInt(adeDate.format('MM'))

              if (monthNow == monthOfAde) {
                // credits available in next month
                var p = _vue.practices[x].finalAmmount
                p = parseFloat(p.replace(',', '.'))
                countNextmonth = countNextmonth + p
                _vue.countPracticesNextMonth = _vue.countPracticesNextMonth + 1
                _vue.arrayPracticesNextMonth.push(_vue.practices[x])

              } else {

                  // credits available yet
                  _vue.arrayPracticesAvailable.push(_vue.practices[x])
                  var p = _vue.practices[x].finalAmmount
                  p = parseFloat(p.replace(',', '.'))
                  count = count + p

              }

            }

            console.warn(' AVAILABLE NOW ')
            console.warn(_vue.arrayPracticesAvailable)
            console.warn(' AVAILABLE NEXT MONTH ')
            console.warn(_vue.arrayPracticesNextMonth)
            // next Month count
            _vue.countValuesNextMonth = countNextmonth.toFixed(2)

            // Available in this month count
            _vue.countValues = count.toFixed(2)
            _vue.addAllItemToDisposal()
            _vue.loaded = true
            _vue.loadingState = false
          })
          .catch(resp => {
            console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor')
            _vue.loadingState = false
          })

      }
    },
  },
  watch: {
    iban: function(value) {
      this.iban = value.toUpperCase().trim()
      this.iban = this.iban.replace(' ', '')
    },
    flow: function(val) {
      this.checkIfExistUser()

      if( val == 'cdp' ){
        this.min_disposal_price_cdp = process.env.MIN_DISPOSAL_PRICE_CDP
      }else{
        this.min_disposal_price_cdp = process.env.MIN_DISPOSAL_PRICE_POSTE
      }

    },
    async getProfile() {
      await this.checkIfExistUser()
    },
  },
  created() {

    console.log('Section 1 LOADED')

  },

  async mounted() {

    await this.checkIfExistUser()

  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    }),

  },
}
</script>

<style lang="css" scoped>

.small{
  font-size: 12px!important;
}

.selectListBox {
  background: #d4ebe9;
  border: 1px solid grey;
  padding: 3%;
  max-height: 254px;
  height: 254px;
  overflow-y: scroll;
  transition: all .1s;
}
.lightYellow {
  background:   #f393241c
}
  .custLabelFontSize{
    font-size: 14px;
  }

  .selectBlock{
    background: #eeeeee;
    border: 1px solid #a5a5a5;
    border-top: none;
  }

  .blockActive{
    background: white;
    border-bottom: none!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/cessioni/practicesToDo.vue